// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3fgxX","info":"Note_info__3E4OE","note":"Note_note__ap998","actions":"Note_actions__r3wPQ"};